import { render } from "./ListeInfoFooterPage.vue?vue&type=template&id=08d0b57e&ts=true"
import script from "./ListeInfoFooterPage.vue?vue&type=script&lang=ts"
export * from "./ListeInfoFooterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__